import { render } from "./LogItem.vue?vue&type=template&id=395a9548&scoped=true"
import script from "./LogItem.vue?vue&type=script&lang=js"
export * from "./LogItem.vue?vue&type=script&lang=js"

import "./LogItem.vue?vue&type=style&index=0&id=395a9548&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395a9548"]])

export default __exports__